'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouterRedux = require('react-router-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _semanticUiReact = require('semantic-ui-react');

var _reactFacebookLogin = require('react-facebook-login');

var _reactFacebookLogin2 = _interopRequireDefault(_reactFacebookLogin);

var _reactGoogleLogin = require('react-google-login');

var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);

var _constants = require('../../constants');

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    loggingIn: state.auth.loggingIn,
    registerError: state.auth.registerError,
    loginError: state.auth.loginError,
    token: state.company.token,
    edureka_user_id: state.auth.edureka_user_id,
    full_sso_data: state.auth.full_data,
    edureka_user_exists: state.auth.edureka_user_exists,
    edureka_user_exists_checking: state.auth.edureka_user_exists_checking,
    company: state.company.name,
    base_url: state.company.base_url,
    use_sso_login: state.company.use_sso_login,
    redirect_url: state.company.redirect_url,
    sso_endpoint: state.company.sso_endpoint,
    ReactGA: state.company.ReactGA,
    api_key: state.company.api_key,
    is_hiration: state.company.is_hiration
  };
}, {
  pushState: _reactRouterRedux.push,
  login: authActions.login,
  register: authActions.register,
  check_edureka_user_exists: authActions.check_edureka_user_exists,
  facebook: authActions.facebook,
  google: authActions.google,
  logout: authActions.logout,
  getUserId: authActions.getUserId,
  forceSetUser: authActions.forceSetUser,
  saveSSODetail: authActions.saveSSODetail
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Login);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call.apply(_ref, [this].concat(args))), _this), _this.state = { loginVisible: false }, _this.handleSubmit = function (event) {
      event.preventDefault();
      _this.props.login(_this.state.username, _this.state.password);
      _this.setState({ password: '', username: '' });
    }, _this.handleRegister = function (event) {
      event.preventDefault();
      _this.props.register(_this.state.name, _this.state.registerpassword, _this.state.registerpassword, _this.state.email, _this.props.api_key);
      _this.setState({ name: '', email: '', registerpassword: '' });
    }, _this.facebook = function (access_token) {
      _this.props.facebook(access_token);
    }, _this.responseGoolgeSuccess = function (data) {
      _this.props.google(data.accessToken);
      _this.props.ReactGA.event({
        category: 'LoginSuccess',
        action: 'Google-Login',
        label: 'Time: ' + Date.now()
      });
    }, _this.responseGoolgeFailure = function (data) {
      // console.log(data);
      //alert('Oops looks like there was an error!');
    }, _this.handleChange = function (e, _ref2) {
      var name = _ref2.name,
          value = _ref2.value;
      return _this.setState((0, _defineProperty3.default)({}, name, value));
    }, _this.changeLoginVisibility = function () {
      _this.setState({ loginVisible: !_this.state.loginVisible });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Login, [{
    key: 'responseFacebook',
    value: function responseFacebook(response) {
      this.facebook(response.accessToken);
      this.props.ReactGA.event({
        category: 'LoginSuccess',
        action: 'Facebook-Login',
        label: 'Time: ' + Date.now()
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {

      if (this.props.is_hiration) {
        this.props.forceSetUser();
      }

      if (this.props.use_sso_login && !this.props.token) {
        window.location.href = this.props.redirect_url;
      }

      if (this.props.token && this.props.use_sso_login) {
        this.props.getUserId(this.props.token, this.props.sso_endpoint, this.props.redirect_url);
      }

      // if (this.props.edureka_user_id) {
      //   this.props.check_edureka_user_exists(this.props.edureka_user_id);
      // }
      // if(this.props.edureka_user_exists){
      //   console.log('sad');
      //   this.props.login(this.props.edureka_user_id + '@edureka.com',
      //    this.props.edureka_user_id);
      // } else {
      //   console.log('verysad');
      // this.props.register(this.props.edureka_user_id, this.props.edureka_user_id,
      // this.props.edureka_user_id, this.props.edureka_user_id + '@edureka.com');
      // }

      if (this.props.user) {
        this.props.pushState(this.props.base_url + '/dashboard');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var domain;
      var password;

      if (this.props.company == 'Edureka') {
        domain = 'edureka.com';
        password = 'edureka';
      } else {
        domain = window.location.hostname;
        password = window.location.hostname;
      }
      // console.log(nextProps.user);
      if (this.props != nextProps) {
        // console.log(nextProps);
        if (!this.props.user && nextProps.user && this.props.is_hiration) {
          this.props.pushState(this.props.base_url + '/dashboard');
        }
        if (!this.props.edureka_user_id && nextProps.edureka_user_id) {
          if (domain === 'edureka.com') {
            this.props.check_edureka_user_exists(nextProps.edureka_user_id);
          } else {
            // console.log(nextProps.edureka_user_id + '@' + domain);
            this.props.check_edureka_user_exists(nextProps.edureka_user_id + '@' + domain);
          }
        }
        if (this.props.edureka_user_exists_checking && !nextProps.edureka_user_exists_checking) {
          if (!nextProps.user) {
            if (nextProps.edureka_user_exists) {
              this.props.login(nextProps.edureka_user_id + '@' + domain, nextProps.edureka_user_id + password);
            } else {
              if (domain === 'edureka.com') {
                this.props.register(this.props.edureka_user_id, this.props.edureka_user_id + password, this.props.edureka_user_id + password, this.props.edureka_user_id + '@' + domain, this.props.api_key);
              } else {
                this.props.register(this.props.edureka_user_id + '@' + domain, this.props.edureka_user_id + password, this.props.edureka_user_id + password, this.props.edureka_user_id + '@' + domain, this.props.api_key);
              }
            }
          } else {
            this.props.pushState(this.props.base_url + '/dashboard');
          }
        }
      }
    }

    // componentDidMount() {
    //   console.log(this.props);
    //   console.log(this.props.edureka_user_id);
    //
    //   if (this.props.edureka_user_id) {
    //     console.log(this.props.edureka_user_id);
    //     this.props.login(this.props.edureka_user_id, this.props.edureka_user_id);
    //   }
    // }


  }, {
    key: 'render',


    // componentWillReceiveProps(nextProps){
    //   if(nextProps.user && !nextProps.loggingIn){
    //     this.props.pushState(this.props.base_url + '/dashboard');
    //   }
    // }

    value: function render() {
      var _this2 = this;

      var _props = this.props,
          user = _props.user,
          logout = _props.logout,
          token = _props.token;
      var _state = this.state,
          username = _state.username,
          password = _state.password,
          email = _state.email,
          name = _state.name,
          registerpassword = _state.registerpassword;

      var styles = require('./Login.scss');
      // const gifImage = require('./resume_designs_home.gif');
      var loginVisible = this.state.loginVisible;

      //let { username, password, email } = this.props.registerError;

      //if(loginVisible){
      if (!this.props.use_sso_login) {
        if (loginVisible) {
          return _react2.default.createElement(
            'div',
            { className: styles.loginPage + ' container' },
            _react2.default.createElement(
              'div',
              { style: { display: 'flex' } },
              _react2.default.createElement(
                'div',
                { className: styles.superWrapper, style: { textAlign: 'center', padding: '20px 0px' } },
                _react2.default.createElement(
                  'h3',
                  { style: { color: 'rgba(255,255,255,.9)', paddingTop: '20px', textAlign: 'center', margin: '0px 60px 10px 60px' } },
                  '100+ Sample Job Profiles | 30+ Designs'
                ),
                _react2.default.createElement(
                  'p',
                  { style: { color: 'rgba(255,255,255,.9)' } },
                  ' Edit & Download Your Resume in Minutes'
                ),
                _react2.default.createElement(_reactPlayer2.default, {
                  url: 'https://streamable.com/4m6e3',
                  playing: true,
                  muted: true,
                  autoplay: true,
                  loop: true,
                  controls: false,
                  onError: function onError() {
                    _this2.props.ReactGA.event({
                      category: 'LoginVideo',
                      action: 'video_error',
                      label: 'Time: ' + Date.now()
                    });
                  },
                  onStart: function onStart() {
                    _this2.props.ReactGA.event({
                      category: 'LoginVideo',
                      action: 'video_started',
                      label: 'Time: ' + Date.now()
                    });
                  } })
              ),
              _react2.default.createElement(
                'div',
                { style: { margin: '0 auto' } },
                _react2.default.createElement(_reactHelmet2.default, { title: 'Login' }),
                !user && _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { inverted: true, className: styles.widthWrapper, style: { padding: '20px 0px', margin: '0 auto', backgroundColor: 'transparent' } },
                  _react2.default.createElement(
                    'h1',
                    { style: { textAlign: 'center', borderBottom: '1px solid lightgrey', paddingBottom: '30px', margin: '0px 60px 10px 60px' } },
                    'Login to create your Resume'
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: { textAlign: 'center' } },
                    this.props.loginError['username'] && _react2.default.createElement(
                      'p',
                      { style: { color: 'red' } },
                      this.props.loginError['username'][0]
                    ),
                    this.props.loginError['password'] && _react2.default.createElement(
                      'p',
                      { style: { color: 'red' } },
                      this.props.loginError['password'][0]
                    ),
                    this.props.loginError['email'] && _react2.default.createElement(
                      'p',
                      { style: { color: 'red' } },
                      this.props.loginError['email'][0]
                    ),
                    this.props.loginError['non_field_errors'] && _react2.default.createElement(
                      'p',
                      { style: { color: 'red' } },
                      this.props.loginError['non_field_errors'][0]
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Form,
                    { loading: this.props.loggingIn },
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { style: { display: 'block', margin: '0px 60px 20px 60px' } },
                      _react2.default.createElement(_semanticUiReact.Form.Input, { placeholder: 'Email', name: 'username', value: username, onChange: this.handleChange })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { style: { display: 'block', margin: '0px 60px 20px 60px' } },
                      _react2.default.createElement(_semanticUiReact.Form.Input, { type: 'password', placeholder: 'Password', name: 'password', value: password, onChange: this.handleChange })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { style: { display: 'block', textAlign: 'center', marginRight: '60px', marginLeft: '60px', paddingBottom: '5px' } },
                      _react2.default.createElement(_semanticUiReact.Form.Button, { style: { width: '100%' }, primary: true, type: 'submit', size: 'small', onClick: this.handleSubmit, content: 'LOGIN' }),
                      _react2.default.createElement(
                        'p',
                        { style: { fontSize: '14px', textAlign: 'left', paddingTop: '4px', paddingLeft: '10px' } },
                        _react2.default.createElement(
                          'a',
                          { onClick: function onClick() {
                              return window.location.href = 'accounts/password/reset/';
                            } },
                          'Forgot Password?'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { style: { fontSize: '14px', textAlign: 'center', paddingLeft: '20px', paddingRight: '20px' } },
                      'If you dont have an account you can ',
                      _react2.default.createElement(
                        'a',
                        { onClick: this.changeLoginVisibility },
                        'Sign Up'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { style: { textAlign: 'center', display: 'block', justifyContent: 'space-around', margin: '19px 60px 40px 60px' } },
                      _react2.default.createElement(_reactFacebookLogin2.default, {
                        appId: _constants.FACEBOOK_API_KEY,
                        autoLoad: false,
                        fields: 'name,email,picture',
                        size: 'small',
                        cssClass: styles.fbButton + ' ui button',
                        callback: this.responseFacebook.bind(this)
                      }),
                      _react2.default.createElement(
                        _reactGoogleLogin2.default,
                        {
                          clientId: _constants.GOOGLE_API_KEY,
                          onSuccess: this.responseGoolgeSuccess.bind(this),
                          onFailure: this.responseGoolgeFailure.bind(this),
                          className: 'ui button small',
                          style: { backgroundColor: '#db3236', color: 'white', marginTop: '20px', width: '100%' }
                        },
                        _react2.default.createElement(
                          'span',
                          { className: styles.googleButton },
                          'Login with Google'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { style: { fontSize: '10px', textAlign: 'center', paddingLeft: '20px', paddingRight: '20px' } },
                      '* By using Hiration\'s',
                      ' Resume Builder, you are agreeing to our ',
                      _react2.default.createElement(
                        'a',
                        { href: 'http://www.hiration.com/terms-and-conditions/' },
                        'Terms of Service'
                      ),
                      ' & ',
                      _react2.default.createElement(
                        'a',
                        { href: 'http://www.hiration.com/privacy/' },
                        'Privacy Policy'
                      )
                    )
                  )
                ),
                user && _react2.default.createElement(
                  'div',
                  null,
                  'Please Wait...'
                )
              )
            )
          );
        } else {
          return _react2.default.createElement(
            'div',
            { className: styles.loginPage + ' container' },
            _react2.default.createElement(
              'div',
              { style: { display: 'flex' } },
              _react2.default.createElement(
                'div',
                { className: styles.superWrapper, style: { textAlign: 'center', padding: '20px 0px' } },
                _react2.default.createElement(
                  'h3',
                  { style: { color: 'rgba(255,255,255,.9)', textAlign: 'center', paddingTop: '20px', margin: '0px 60px 10px 60px' } },
                  '100+ Sample Job Profiles | 30+ Designs'
                ),
                _react2.default.createElement(
                  'p',
                  { style: { color: 'rgba(255,255,255,.9)' } },
                  ' Edit & Download Your Resume in Minutes'
                ),
                _react2.default.createElement(_reactPlayer2.default, {
                  url: 'https://streamable.com/4m6e3',
                  playing: true,
                  muted: true,
                  autoplay: true,
                  loop: true,
                  controls: false })
              ),
              _react2.default.createElement(
                'div',
                { style: { margin: '0 auto' } },
                _react2.default.createElement(_reactHelmet2.default, { title: 'Login' }),
                !user && _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { inverted: true, className: styles.widthWrapper, style: { padding: '20px 0px', margin: '0 auto', backgroundColor: 'transparent' } },
                  _react2.default.createElement(
                    'h1',
                    { style: { textAlign: 'center', borderBottom: '1px solid lightgrey', paddingBottom: '30px', margin: '0px 60px 10px 60px' } },
                    'Signup to create your Resume'
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: { textAlign: 'center' } },
                    this.props.registerError['username'] && _react2.default.createElement(
                      'p',
                      { style: { color: 'red' } },
                      this.props.registerError['username'][0]
                    ),
                    this.props.registerError['password1'] && _react2.default.createElement(
                      'p',
                      { style: { color: 'red' } },
                      this.props.registerError['password1'][0]
                    ),
                    this.props.registerError['email'] && _react2.default.createElement(
                      'p',
                      { style: { color: 'red' } },
                      this.props.registerError['email'][0]
                    ),
                    this.props.registerError['non_field_errors'] && _react2.default.createElement(
                      'p',
                      { style: { color: 'red' } },
                      this.props.registerError['non_field_errors'][0]
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Form,
                    { loading: this.props.loggingIn },
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { style: { display: 'block', margin: '0px 60px 20px 60px' } },
                      _react2.default.createElement(_semanticUiReact.Form.Input, { type: 'email', placeholder: 'Email', name: 'email', value: email, onChange: this.handleChange })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { style: { display: 'block', margin: '0px 60px 20px 60px' } },
                      _react2.default.createElement(_semanticUiReact.Form.Input, { type: 'password', placeholder: 'Password', name: 'registerpassword', value: registerpassword, onChange: this.handleChange })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { style: { display: 'block', textAlign: 'center', marginRight: '60px', marginLeft: '60px', paddingBottom: '5px' } },
                      _react2.default.createElement(_semanticUiReact.Form.Button, { style: { width: '100%' }, primary: true, type: 'submit', size: 'small', onClick: this.handleRegister, content: 'SIGNUP' })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { style: { textAlign: 'center', display: 'block', justifyContent: 'space-around', margin: '19px 60px 40px 60px' } },
                      _react2.default.createElement(_reactFacebookLogin2.default, {
                        appId: _constants.FACEBOOK_API_KEY,
                        autoLoad: false,
                        fields: 'name,email,picture',
                        size: 'small',
                        cssClass: styles.fbButton + ' ui button',
                        callback: this.responseFacebook.bind(this)
                      }),
                      _react2.default.createElement(
                        _reactGoogleLogin2.default,
                        {
                          clientId: _constants.GOOGLE_API_KEY,
                          onSuccess: this.responseGoolgeSuccess.bind(this),
                          onFailure: this.responseGoolgeFailure.bind(this),
                          className: 'ui button small',
                          style: { backgroundColor: '#db3236', color: 'white', marginTop: '20px', width: '100%' }
                        },
                        _react2.default.createElement(
                          'span',
                          { className: styles.googleButton },
                          'Login with Google'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { style: { fontSize: '14px', textAlign: 'center', paddingLeft: '20px', paddingRight: '20px' } },
                      'If you already have an account you can ',
                      _react2.default.createElement(
                        'a',
                        { onClick: this.changeLoginVisibility },
                        'Login'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { style: { fontSize: '10px', textAlign: 'center', paddingLeft: '20px', paddingRight: '20px' } },
                      '* By using Hiration\'s',
                      ' Resume Builder, you are agreeing to our ',
                      _react2.default.createElement(
                        'a',
                        { href: 'http://hiration.com/terms-and-conditions/' },
                        'Terms of Service'
                      ),
                      ' & ',
                      _react2.default.createElement(
                        'a',
                        { href: 'http://www.hiration.com/privacy/' },
                        'Privacy Policy'
                      )
                    )
                  )
                ),
                user && _react2.default.createElement(
                  'div',
                  null,
                  'Please Wait...'
                )
              )
            )
          );
        }
      } else {
        return _react2.default.createElement('div', { style: { marginTop: 200 } });
      }
    }
  }]);
  return Login;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  login: _react.PropTypes.func,
  logout: _react.PropTypes.func,
  facebook: _react.PropTypes.func,
  pushState: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = Login;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Login/Login.js
// module id = 1761
// module chunks = 0